<script>
export default {
    data() {
        return {
            downloadEnabled: true,
            latencyEnable: false,
            allDone: false,
            resultKind: null,
        }
    },
    props: ['component'],
    translate25Context: 'troubleshooting',
    methods: {
        onDownloadDone(payload) {
            this.resultKind = payload?.resultKind || null;
            this.latencyEnable = true;
        }
    }
};
</script>

<template>
    <div class="troubleshooting-bandwith2-container">

        <troubleshooting-bandwith2-download ref="download" :enabled="downloadEnabled" :url="component.url"
            :segment-duration="component.segment_duration || '1s'"
            @done="onDownloadDone"></troubleshooting-bandwith2-download>

        <troubleshooting-bandwith-latency ref="latency" :enabled="latencyEnable" :url="component.url"
            @done="allDone = true"></troubleshooting-bandwith-latency>

        <div class="troubleshooting-bandwith2-messages" v-if="resultKind">
            <f-hint v-if="resultKind === 'full_ok'" icon="fa6-check">
                <template #message>{{ $vt('Your connection can sustain the highest quality (3 Mbps). Playback should be smooth.') }}</template>
            </f-hint>
            <f-hint type="notice" v-if="resultKind === 'partial_ok'" icon="fa6-triangle-exclamation">
                <template #message>{{ $vt('Your connection may struggle with the highest quality. You might experience occasional buffering.') }}</template>
            </f-hint>
            <f-hint type="notice" v-if="resultKind === 'warning_only'" icon="fa6-triangle-exclamation">
                <template #message>{{ $vt('Your connection is unstable and may cause frequent buffering or quality drops.') }}</template>
            </f-hint>
            <f-hint type="negative" v-if="resultKind === 'unreachable'" icon="fa6-triangle-exclamation">
                <template #message>{{ $vt('Unable to download the test segments (HTTP error). Please contact Vodalys support.') }}</template>
            </f-hint>
            <f-hint type="negative" v-if="resultKind === 'full_ko'" icon="fa6-triangle-exclamation">
                <template #message>{{ $vt('Your connection is too slow to stream even the lowest quality available.') }}</template>
            </f-hint>
        </div>
    </div>
</template>

<style lang="scss">
.troubleshooting-bandwith2-container {
    display: flex;
    gap: 33px;
    flex-wrap: wrap;

    .troubleshooting-bandwith2-explanation {
        flex: 0 0 100%;
        margin: 0;
        font-family: Lato;
        font-size: 14px;
        color: #666;
    }

    .troubleshooting-bandwith-latency {
        flex: 1 1 auto
    }

    .troubleshooting-bandwith2 {
        flex: 1 1 66%;
    }

    .troubleshooting-bandwith2-messages {
        flex: 0 0 100%;
        width: 100%;
    }
}

@media (max-width: 500px) {
    .troubleshooting-bandwith2-container {

        .troubleshooting-bandwith2,
        .troubleshooting-bandwith-latency {
            flex: 0 1 278px;
        }
    }
}
</style>
